var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookedCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#dbdbdb",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.107 10.425H10.263a.262.262 0 0 0-.263.261v17.236c0 .144.118.26.263.26h14.844a.262.262 0 0 0 .263-.26V10.686a.262.262 0 0 0-.263-.26",
    stroke: "#000",
    strokeWidth: 0.717,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.456 11.777h-11.34a.262.262 0 0 0-.262.262v13.738c0 .144.118.26.263.26h11.34a.262.262 0 0 0 .263-.26V12.039a.262.262 0 0 0-.264-.262",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.108 9.623h-2.542A1.897 1.897 0 0 0 17.686 8c-.958 0-1.752.707-1.881 1.623h-2.543a.262.262 0 0 0-.264.262v2.788c0 .144.118.262.264.262h8.846a.263.263 0 0 0 .264-.262V9.885a.262.262 0 0 0-.264-.262",
    stroke: "#000",
    strokeWidth: 0.717,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.757 14.612a.706.706 0 0 1-.709.703.706.706 0 0 1-.708-.703c0-.388.317-.703.708-.703.391 0 .709.315.709.703",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#013177",
    d: "M15.979 14.612h5.729-5.729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.708 14.873h-5.729a.262.262 0 0 1-.263-.261c0-.145.118-.262.263-.262h5.729c.145 0 .263.117.263.262a.262.262 0 0 1-.263.261M14.757 16.89a.706.706 0 0 1-.709.703.706.706 0 0 1-.708-.703c0-.389.317-.703.708-.703.391 0 .709.314.709.703",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#013177",
    d: "M15.979 16.89h5.729-5.729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.708 17.151h-5.729a.262.262 0 0 1-.263-.261c0-.144.118-.261.263-.261h5.729c.145 0 .263.117.263.26a.262.262 0 0 1-.263.262M14.757 19.168a.706.706 0 0 1-.709.703.706.706 0 0 1-.708-.703c0-.389.317-.704.708-.704.391 0 .709.315.709.704",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#013177",
    d: "M15.979 19.168h5.729-5.729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.708 19.43h-5.729a.262.262 0 0 1-.263-.262c0-.145.118-.262.263-.262h5.729c.145 0 .263.117.263.262a.262.262 0 0 1-.263.261M14.757 21.446a.706.706 0 0 1-.709.703.706.706 0 0 1-.708-.703c0-.389.317-.703.708-.703.391 0 .709.314.709.703",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#013177",
    d: "M15.979 21.446h5.729-5.729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.708 21.707h-5.729a.262.262 0 0 1-.263-.261c0-.145.118-.262.263-.262h5.729a.262.262 0 1 1 0 .523",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.456 18.579-1.04-.713a.265.265 0 0 0-.367.067l-2.998 4.315a.26.26 0 0 0 .067.364l1.04.712a.262.262 0 0 0 .366-.067l2.999-4.315a.261.261 0 0 0-.067-.363z",
    stroke: "#000",
    strokeWidth: 0.717,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.203 12.11c-.3.055-.56.222-.734.471l-3.622 5.213a.26.26 0 0 0 .067.364l1.445.99a.264.264 0 0 0 .366-.068l3.622-5.213a1.129 1.129 0 0 0-.29-1.575 1.141 1.141 0 0 0-.854-.182z",
    stroke: "#000",
    strokeWidth: 0.717,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.624 17.577a.26.26 0 0 1-.067-.364l1.615-2.324-.395-.905a.26.26 0 0 1 .137-.343.264.264 0 0 1 .346.136l.453 1.038a.26.26 0 0 1-.025.252L23.99 17.51a.262.262 0 0 1-.366.067z",
    stroke: "#000",
    strokeWidth: 0.844,
    fill: "#F1F1F1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m16.22 25.013 2.303-1.747-1.475-1.01z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookedCompleted);
export default __webpack_public_path__ + "static/media/booked_completed.2ff36f53169eae7efa74c62362aa9142.svg";
export { ForwardRef as ReactComponent };